import { useState, useRef, useEffect } from "react";
import { Dialog, Popover } from "@headlessui/react";
import {
  Bars3Icon,
  XMarkIcon,
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
} from "@heroicons/react/24/outline";
import { NavLink, Link } from "react-router-dom";
import { routes } from "../../routes";
import { trendyLogo_img, tgIcon, vkIcon } from "../../images";
import NavItem from "./navItem";

export default function Example() {
  const [showToolTip, setShowToolTip] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [supportMenuOpen, setSupportMenuOpen] = useState(false);
  const [mobileSupportMenuOpen, setMobileSupportMenuOpen] = useState(false);
  const [emailCopied, setEmailCopied] = useState(false);
  const supportMenuRef = useRef(null);

  const handleMouseEnter = () => {
    setShowToolTip(true);
  };
  const handleMouseLeave = () => {
    setShowToolTip(false);
  };

  const handleSupportClick = () => {
    setSupportMenuOpen((prev) => !prev);
  };

  const handleMobileSupportClick = () => {
    setMobileSupportMenuOpen((prev) => !prev);
  };

  const handleCopyEmail = () => {
    const email = process.env.REACT_APP_SUPPORT_EMAIL;
    navigator.clipboard.writeText(email).then(() => {
      setEmailCopied(true);
      setSupportMenuOpen(false);
      setMobileSupportMenuOpen(false);
      setShowToolTip(false);
      setTimeout(() => setEmailCopied(false), 2500);
    });
  };

  // Закрываем меню поддержки при клике вне его
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (supportMenuRef.current && !supportMenuRef.current.contains(event.target)) {
        setSupportMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Уведомление о копировании почты */}
      {emailCopied && (
        <div className="fixed bottom-6 left-1/2 z-[100] -translate-x-1/2 rounded-lg bg-gray-800 px-4 py-2 text-sm text-white shadow-lg dark:bg-gray-700">
          Почта скопирована в буфер обмена
        </div>
      )}

      <nav
        className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 lg:px-8 lg:py-4"
        aria-label="Global"
      >
        {routes.map((route, ind) => {
          if (route.path === "/") {
            return (
              <Link to={route.path} key={ind}>
                <img
                  className="ping-one-time  animation-delay-2 w-[200px] basis-1/5"
                  src={trendyLogo_img}
                  alt="Trendy Shop"
                />
              </Link>
            );
          }
          return null;
        })}

        <div className="flex md:hidden">
          <div className="relative me-8">
            <button
              type="button"
              onClick={handleMobileSupportClick}
              className="flex items-center"
            >
              <ChatBubbleLeftRightIcon className="h-6 w-6 text-green-500 dark:text-green-500" />
            </button>
            {mobileSupportMenuOpen && (
              <div className="absolute right-0 top-8 z-50 flex flex-col gap-2 rounded-xl border border-green-500 bg-[#f7f8fa] p-3 shadow-lg dark:bg-[#222222]">
                <a
                  href={process.env.REACT_APP_SUPPORT_TG_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-700 hover:opacity-80 dark:text-gray-200"
                  onClick={() => setMobileSupportMenuOpen(false)}
                >
                  <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#2AABEE]">
                    <img src={tgIcon} alt="Telegram" className="h-3.5 w-3.5" />
                  </span>
                  Telegram
                </a>
                <a
                  href={process.env.REACT_APP_SUPPORT_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-700 hover:opacity-80 dark:text-gray-200"
                  onClick={() => setMobileSupportMenuOpen(false)}
                >
                  <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#0077FF]">
                    <img src={vkIcon} alt="ВКонтакте" className="h-3.5 w-3.5" />
                  </span>
                  ВКонтакте
                </a>
                <button
                  type="button"
                  className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-700 hover:opacity-80 dark:text-gray-200"
                  onClick={handleCopyEmail}
                >
                  <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gray-500">
                    <EnvelopeIcon className="h-3.5 w-3.5 text-white" />
                  </span>
                  Почта
                </button>
              </div>
            )}
          </div>
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>

            <Bars3Icon className="h-6 w-6 dark:text-white" aria-hidden="true" />
          </button>
        </div>

        <Popover.Group className="hidden md:flex md:items-center md:justify-center md:space-x-10">
          <NavItem name="Nintendo" group="nintendo" />
          <NavItem name="Steam" group="steam" />
          <NavItem name="PlayStation" group="playstation" />
          <div
            ref={supportMenuRef}
            className="relative inline-block"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button
              type="button"
              onClick={handleSupportClick}
              className="flex items-center"
            >
              <ChatBubbleLeftRightIcon
                className="text-green-500 hover:text-green-400 md:w-10 lg:w-10"
              />
            </button>
            {!supportMenuOpen && !emailCopied && (
              <span
                className={
                  "absolute right-2 block whitespace-nowrap rounded-md border border-green-500 p-1 text-xs text-green-500 duration-300 md:-bottom-[30px] lg:-bottom-[30px] " +
                  (showToolTip ? " opacity-100 " : " invisible opacity-0")
                }
              >
                Служба поддержки
                <span className=" absolute -top-[5px] right-4 block h-2 w-2 -rotate-45 border-r border-t border-green-500 bg-[#f7f8fa] dark:bg-[#222222] ">
                  {""}
                </span>
              </span>
            )}
            {supportMenuOpen && (
              <div className="absolute right-0 top-12 z-50 flex flex-col gap-3 rounded-xl border border-green-500 bg-[#f7f8fa] p-4 shadow-lg dark:bg-[#222222]">
                <a
                  href={process.env.REACT_APP_SUPPORT_TG_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-700 hover:opacity-80 dark:text-gray-200"
                  onClick={() => setSupportMenuOpen(false)}
                >
                  <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-[#2AABEE]">
                    <img src={tgIcon} alt="Telegram" className="h-4 w-4" />
                  </span>
                  Telegram
                </a>
                <a
                  href={process.env.REACT_APP_SUPPORT_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-700 hover:opacity-80 dark:text-gray-200"
                  onClick={() => setSupportMenuOpen(false)}
                >
                  <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-[#0077FF]">
                    <img src={vkIcon} alt="ВКонтакте" className="h-4 w-4" />
                  </span>
                  ВКонтакте
                </a>
                <button
                  type="button"
                  className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-700 hover:opacity-80 dark:text-gray-200"
                  onClick={handleCopyEmail}
                >
                  <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-gray-500">
                    <EnvelopeIcon className="h-4 w-4 text-white" />
                  </span>
                  Почта
                </button>
              </div>
            )}
          </div>
        </Popover.Group>
      </nav>
      <Dialog
        as="div"
        className=" md:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />

        <Dialog.Panel className=" fixed inset-y-0 right-0 z-10 w-full overflow-y-auto  bg-[#dce1e6]  dark:bg-[#141414] sm:ring-1 sm:ring-gray-900/10">
          <div className="flex justify-center px-2">
            <div className="container ">
              <div className=" flex items-center justify-between rounded-b-xl bg-[#f7f8fa] px-6 py-6 dark:bg-[#222222]">
                {routes.map((route, ind) => {
                  if (route.path === "/") {
                    return (
                      <Link
                        key={ind}
                        to={route.path}
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <img
                          className=" w-[200px]"
                          src={trendyLogo_img}
                          alt=" Trendy Shop"
                        />
                      </Link>
                    );
                  }
                  return null;
                })}

                <button
                  type="button"
                  className="-m-2.5 rounded-md p-2.5 text-gray-700"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <span className="sr-only">Close menu</span>
                  <XMarkIcon
                    className="h-6 w-6 dark:text-white "
                    aria-hidden="true"
                  />
                </button>
              </div>
              <div className=" mt-2 flow-root rounded-3xl bg-[#f7f8fa]  px-6 py-6 dark:bg-[#222222]">
                <div className="-my-6 divide-y divide-gray-500/10">
                  <div className="space-y-2 py-6">
                    {routes.map((route, ind) => {
                      if (route.display) {
                        return (
                          <NavLink
                            key={ind}
                            to={route.path}
                            className="nav-link"
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            {route.title}
                          </NavLink>
                        );
                      }
                      return null;
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </>
  );
}
